<template>
  <div class="travelsearch">
    <div class="search-box">
      <div class="input-box">
        <img src="../../assets/travelAgency/ic_search.png" alt class="search-icon" />
        <input
          style
          type="text"
          placeholder="投诉单号/投诉人姓名/被投诉对象名称"
          class="search-input"
          v-model="inputParams"
          @input="onChange"
        />
      </div>
      <div class="search-btn" @click="$router.go(-1)">取消</div>
    </div>
    <div class="latest-box" v-if="inputParams == '' && appraiseKeyword.length > 0">
      <div class="title-box">
        <div class="title">最近搜索</div>
        <img
          src="../../assets/travelAgency/ic_delete.png"
          alt
          class="delete-icon"
          @click="latestDelete"
        />
      </div>
      <div class="tags-box">
        <div
          class="tag"
          v-for="(lists,index) in appraiseKeyword"
          :key="index"
          @click="inputParams = lists,onChange(lists) "
        >{{lists}}</div>
      </div>
    </div>
    <div class="history-box" v-if="inputParams == '' && appraiseHistory.length > 0">
      <div class="title-box">
        <div class="title">浏览历史</div>
        <img
          src="../../assets/travelAgency/ic_delete.png"
          alt
          class="delete-icon"
          @click="historyDelete"
        />
      </div>
      <div class="list">
        <div class="item" v-for="(item,index) in complainList" :key="index">
          <div class="item-head">
            <div class="name">{{item.defendant_name}}</div>
            <div class="btn hg">{{item.statue_name}}</div>
          </div>

          <div class="item-cont">
            <div>投诉人：{{item.complain_name}}</div>
            <div>投诉单号：{{item.orderNo}}</div>
          </div>

          <div class="score">
            <div class="term">响应时长<span class="red">{{item.answerTime}}分钟</span></div>
            <div class="term">办结时长<span>{{(item.handle_time/60).toFixed(1)}}小时</span></div>
          </div>
        </div>
      </div>

    </div>
    <div class="result-box" v-if="inputParams != ''">
      <div class="title-box">
        <div class="title">搜索结果</div>
      </div>
      <div class="lists-box">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="loadMoreList"
          v-if="complainList.length > 0"
        >
          <div class="list">
              <div class="item" v-for="(item,index) in complainList" :key="index">
                <div class="item-head">
                  <div class="name">{{item.defendant_name}}</div>
                  <div class="btn hg">{{item.statue_name}}</div>
                </div>
                <div class="item-cont">
                  <div>投诉人：{{item.complain_name}}</div>
                  <div>投诉单号：{{item.orderNo}}</div>
                </div>

                <div class="score">
                  <div class="term">响应时长<span class="red">{{item.answerTime}}分钟</span></div>
                  <div class="term">办结时长<span>{{(item.handle_time/60).toFixed(1)}}小时</span></div>
                </div>
              </div>

            </div>
        </van-list>
      </div>
      <empty :type="2" v-if="complainList.length === 0 && !loading"></empty>
    </div>
  </div>
</template>
<script>
    // import bus from '@/utils/bus'
    import { mapState } from 'vuex';
    import empty from 'comps/empty';
    import star from 'comps/star';
    import api from '../../service/modules/appraise';
    export default {
        components: {
            star,
            empty
        },

        data () {
            return {
                inputParams: '',
                complainList: [],
                pageSize: 8,
                // complainList: [],
                finished: false,
                loading: false,
                page: 1,
                total: 0,
                oldInputParams: ''
            };
        },

        computed: {
            ...mapState('appraise', ['appraiseKeyword', 'appraiseHistory'])
        },

        watch: {},

        methods: {
            loadMoreList () {
                this.getList();
            },
            getList () {
                if (this.inputParams && !this.appraiseKeyword.includes(this.inputParams)) {
                    this.$store.dispatch('appraise/setKeyword', [
                        this.inputParams,
                        ...this.appraiseKeyword
                    ]); // 设置搜索记录
                }

                api.notRespondDetail({
                    year: this.urlInfo.year,
                    quarter: this.urlInfo.quarter,
                    type: 'notRespondDetail',
                    cityId: this.urlInfo.cityId,
                    curPage: this.page,
                    pageSize: this.pageSize,
                    inputParams: this.inputParams,
                    complainStatue: 50
                }).then(res => {
                    if (res.ret === 0) {
                        this.loading = false;
                        this.complainList = this.complainList.concat(res.data.list)
                        this.total = res.data.total;
                        if (this.total <= this.page * this.pageSize) {
                            this.finished = true;
                        } else {
                            this.page++;
                        }
                    } else {
                        this.$Message.error('res.data.msg')
                    }
                });
            },
            latestDelete () {
                this.$store.dispatch('appraise/setKeyword', []); // 清空搜索记录
            },
            historyDelete () {
                this.$store.dispatch('appraise/setHistory', []); // 清空浏览记录
            },
            onChange (value) {
                if (value === '') {
                    this.complainList = this.appraiseHistory;
                    this.finished = true;
                } else {
                    if (this.oldInputParams !== this.inputParams) {
                        this.oldInputParams = this.inputParams
                        this.page = 1
                        this.complainList = []
                        this.getList();
                    }
                }
            }
        },

        mounted () {},
        created () {
            this.urlInfo = JSON.parse(sessionStorage.getItem('urlInfo'))
            this.inputParams = this.$route.query.inputParams || '';
            this.getList()
        }
    };
</script>
<style scoped lang="less">
.travelsearch {
  width: 100%;
  height: 100%;
  background: rgba(251, 251, 251, 1);
  box-sizing: border-box;
  padding: 10px 12px 0 12px;
  .search-box {
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 25px;
    .input-box {
      flex: 1;
      margin-right: 12px;
      height: 100%;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding-left: 16px;
      background: rgba(245, 245, 245, 1);
      border-radius: 1px;
      .search-icon {
        width: 15px;
        height: 14px;
        margin-right: 8px;
      }
      input::-webkit-input-placeholder {
        font-size: 12px;

        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 17px;
      }

      .search-input {
        flex: 1;
        background: rgba(245, 245, 245, 1);
      }
    }
    .search-btn {
      width: 40px;
      height: 28px;
      background: rgba(245, 245, 245, 1);
      border-radius: 1px;
      font-size: 12px;

      font-weight: 400;
      color: rgba(54, 179, 116, 1);
      line-height: 28px;
      text-align: center;
    }
  }
  .latest-box {
    margin-bottom: 28px;

    .title-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;

      .title {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 16px;
      }
      .delete-icon {
        width: 18px;
        height: 18px;
      }
    }
    .tags-box {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .tag {
        font-size: 12px;
        font-family: PingFangTC-Regular, PingFangTC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 28px;
        box-sizing: border-box;
        padding: 0 8px;
        background: rgba(255, 255, 255, 1);
        border-radius: 1px;
        border: 1px solid rgba(204, 204, 204, 1);
        margin-right: 16px;
        margin-bottom: 10px;
      }
    }
  }
  .history-box,
  .result-box {
    .title-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;

      .title {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 16px;
      }
      .delete-icon {
        width: 18px;
        height: 18px;
      }
    }
    .list{
      padding: 0 12px 16px 12px;
      .item{
        background:rgba(255,255,255,1);
        box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
        border-radius:3px;
        margin-bottom: 24px;
        &-head{
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 16px 16px 0 16px;
          .name{
            font-size:14px;
            font-family:PingFangSC-Semibold,PingFang SC;
            font-weight:600;
            color:rgba(42,42,42,1);
          }
          .btn{
            min-width:46px;
            line-height: 18px;
            padding: 0 8px;
            background:rgba(255,140,25,1);
            border-radius:9px;
            text-align: center;
            color: #fff;
          }
          .dpj{
            background:rgba(255,140,25,1);
          }
          .hg{
            background:rgba(54,179,116,1);
          }
        }
        &-cont{
          padding: 16px;
          div{
            font-size:12px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(102,102,102,1);
            line-height:12px;
            margin-bottom: 12px;
          }
          div:last-child{
            margin-bottom: 0;
          }
        }
        .score{
          display: flex;
          height: 45px;
          border-top: solid 1Px #EEEEEE;
          .term{
            position: relative;
            flex:1;
            line-height: 45px;
            text-align: center;
            font-size:14px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:#333333;
            span{
              padding-left: 4px;
            }
            .red{
              color: #FF4D4D;
            }
          }
          .term:first-child::after{
            content:'';
            position: absolute;
            right: 0;
            top: 50%;
            height: 12px;
            transform: translateY(-50%);
            border-right: solid 1Px #999999;
          }
        }
      }
    }
  }
}
</style>
